import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { FamilyDashboard } from "../Family/FamilyDashboard";
import { MemberDashboard } from "../Member/MemberDashboard";
import { DonationDashboard } from "../Donation/DonationDashboard";

export const AllGraph = () => {
  const [selectedToggle, setSelectedToggle] = useState("family");
  const [isLoading, setIsLoading] = useState(null);
  const handleToggleClick = (toggleName) => {
    setSelectedToggle(toggleName);
  };

  const tabs = [
    { key: "family", label: "Family" },
    { key: "member", label: "Member" },
    { key: "donation", label: "Donation" },
  ];
  return (
    <div className="ad-page">
      <div className="ad-ph">
        <div>
          <h1 style={{ textTransform: "capitalize" }}>{selectedToggle} Dashboard</h1>
          <p>Live overview of {selectedToggle} activity across the Foundation.</p>
        </div>
        <div className="ad-ph-actions">
          <div style={{ display: "inline-flex", background: "#fff", border: "1px solid var(--line-2)", borderRadius: 10, padding: 3, gap: 2 }}>
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => handleToggleClick(t.key)}
                style={{
                  padding: "7px 14px", borderRadius: 7,
                  fontSize: 13, fontWeight: 600, border: "none",
                  background: selectedToggle === t.key ? "var(--brand-50)" : "transparent",
                  color: selectedToggle === t.key ? "var(--brand-700)" : "var(--fg-3)",
                  cursor: "pointer", fontFamily: "var(--font-sans)",
                }}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="ad-loading"><span className="spin" />Loading…</div>
      ) : (
        <div>
          {selectedToggle === "family" && <FamilyDashboard />}
          {selectedToggle === "member" && <MemberDashboard />}
          {selectedToggle === "donation" && <DonationDashboard />}
        </div>
      )}
    </div>
  );
};
